import React, { useEffect, useState, useRef, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import NoData from "components/App/div/noData";
import Slick from "components/Antd/Slick";
import Card from "./Card";
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";
import { get_product } from "api/v4/finance";
import { Skeleton } from "antd";

export default observer(() => {
  const t = useTranslation();
  const { app, finance } = useStore();

  const [loading, setLoading] = useState(true);
  const [resData, setResData] = useState([]);

  const rcmdDataAry = useMemo(() => {
    if (!resData.length) return [];
    const ary = [];
    resData.map((groupObj) => {
      if (!groupObj.productCollections || !groupObj.productCollections.length) return;
      const categoryObj = groupObj.productCollections[0];
      if (!categoryObj.financialProducts || !categoryObj.financialProducts.length) return;
      ary.push(categoryObj.financialProducts[0]);
    });

    return ary;
  }, [resData]);

  useEffect(() => {
    get_product({
      params: {
        categories: "SIMPLE_EARN",
        limit: -1,
        recommended: true,
        fromPage: 1,
      },
    })
      .then((result) => {
        setResData(result.items);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className={styles.main}>
      <h2 className={styles.title}>{t("finance.recommended")}</h2>

      <div className={styles.content}>
        <Skeleton loading={loading} paragraph={{ rows: 8 }} style={{ padding: "20px 0" }}>
          {!rcmdDataAry.length ? (
            <NoData />
          ) : (
            <Slick
                arrows={!app.isH5}
                infinite={rcmdDataAry.length > (app.isH5 ? 1 : 3)}
                slidesToShow={app.isH5 ? 1 : 3}
            >
              {rcmdDataAry.map((data, index) => (
                <div key={data.id}>
                  <Card data={data} />
                </div>
              ))}
            </Slick>
          )}
        </Skeleton>
      </div>
    </div>
  );
});
